import React, { Component } from 'react'
import PropTypes from 'prop-types'
import style from './Bumper.less'
import minusSVG from 'styles/icons/minus.svg'
import plus from 'styles/icons/plus.svg'
import classNames from 'classnames'

class Bumper extends Component {

  onButtonPress = evt => {
    evt.preventDefault()
    evt.stopPropagation()
    evt.nativeEvent.stopImmediatePropagation()
  }

  handleMinus = () => {
    if (this.props.min < this.props.value) {
      this.props.onMinus()
    }
  }

  handlePlus = () => {
    if (this.props.max > this.props.value) {
      this.props.onPlus()
    } else {
      this.props.onErrorMaxHit()
    }
  }

  render() {
    const minusClasses = classNames({
      [style.bumperButton]: true,
      [style.bumperButtonDisabled]: this.props.value <= this.props.min,
    })

    const plusClasses = classNames({
      [style.bumperButton]: true,
      [style.bumperButtonDisabled]: this.props.value >= this.props.max,
    })

    return (
      <div
        className={style.main}
        data-test="bumper"
      >
        <span
          className={minusClasses}
          onClick={this.handleMinus}
          data-test="bumpDown"
        >
          <svg viewBox={minusSVG.viewBox}>
            <use xlinkHref={`#${minusSVG.id}`} />
          </svg>
        </span>
        <span className={style.contentWrapper}>
          <span data-test="bumperValue">
            {this.props.value}
          </span>
        </span>
        <span
          className={classNames(plusClasses)}
          onClick={this.handlePlus}
          data-test="bumpUp"
        >
          <svg viewBox={plus.viewBox}>
            <use xlinkHref={`#${plus.id}`} />
          </svg>
        </span>
      </div>
    )
  }
}

Bumper.propTypes = {
  value: PropTypes.number,
  onPlus: PropTypes.func,
  onMinus: PropTypes.func,
  onErrorMaxHit: PropTypes.func,
  min: PropTypes.number,
  max: PropTypes.number,
}

export default Bumper
